import { DetailsCard } from "../../../components/detailsCard/detailsCard";
import { DraftSubmission } from "../../../data-model/draftSubmission";
import { useAuthInfoDataGeneration } from "../hooks/useAuthInfoDataGeneration";

interface DraftSubmissionAuthInfoProps {
  authInformation?: DraftSubmission;
}

const DraftSubmissionAuthInfo = (props: DraftSubmissionAuthInfoProps) => {
  const authInfoData = useAuthInfoDataGeneration(props.authInformation);
  if (!authInfoData) return null;
  return (
    <div className="draft-submission-auth-info--container flex flex-col gap-2">
      <div className="draft-submission-auth-info--header text-sm font-bold">
        Auth Information
      </div>
      <div className="draft-submission-auth-info--body">
        <DetailsCard
          details={authInfoData.details}
          elementsInOneRow={authInfoData.elementsInOneRow}
          showBorder={authInfoData.showBorder}
          className="rounded bg-[#F7F9FA] p-4"
        />
      </div>
    </div>
  );
};

export default DraftSubmissionAuthInfo;
